import React from "react";

const PageLoader = ({type}) =>{
    return(
        <div className={`pageLoader ${type}`}></div>
    )
}
export default PageLoader;
